/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable fp/no-loops */
import parse from 'json-to-ast';

import type { RicosDocument } from '../generated/ricos_document';
import type { ValidationError } from '../json-typedef-js-fork/validate';
import type { EditorPluginName } from '../plugin-names';
import { getAstForJsonPointer } from './pointerUtils';
import { validateRicosDocument } from './validate-ricos-document';

type Message = {
  from: number;
  to: number;
  message: string;
};

export function parseFromString(
  str: string,
  options?: {
    plugins?: EditorPluginName[];
  }
): { type: 'ok'; content: RicosDocument } | { type: 'error'; messages: Message[] } {
  let obj;
  try {
    obj = JSON.parse(str);
  } catch (e: any) {
    const error = e as Error;
    const position = getPositionFromJSONError(e);
    return {
      type: 'error',
      messages: [
        position !== undefined
          ? {
              from: position,
              to: position + 1,
              message: error.message,
            }
          : {
              from: 0,
              to: str.length,
              message: error.message,
            },
      ],
    };
  }

  const validationResult = validateRicosDocument(obj, options);
  if (validationResult.type === 'ok') {
    return { type: 'ok', content: validationResult.content };
  }
  const ast = parse(str);

  return {
    type: 'error',
    messages: (validationResult.errors || []).map(convertMessage(ast)),
  };
}

function getPositionFromJSONError(e: Error): number | undefined {
  if (e instanceof SyntaxError) {
    const match = /position (\d+)/.exec(e.message);
    if (match) {
      return parseInt(match[1], 10); // Convert the position to a number.
    }
    return undefined;
  }
}

const convertMessage =
  (ast: parse.ValueNode) =>
  (message: ValidationError): Message => {
    const astForJsonPointer = getAstForJsonPointer(ast, message.instancePath);
    return {
      message: message.message,
      from: astForJsonPointer.property
        ? astForJsonPointer.property.loc!.start.offset
        : astForJsonPointer.value.loc!.start.offset,
      to: astForJsonPointer.value.loc!.end.offset,
    };
  };
